export default {
    day: '2023-11-11',
    content: {
        meta: [
            {
                type: 'change',
                text: '247'
            },
            {
                type: 'bugfix',
                text: '249'
            },
            {
                type: 'new',
                text: '248'
            },
            {
                type: 'new',
                text: '250'
            }
        ],
        mining: [
            {
                unlock: 'miningEnhancement',
                type: 'change',
                text: '244'
            },
            {
                unlock: 'miningPickaxeCrafting',
                type: 'new',
                text: '245'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'new',
                text: '246'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '257',
                balance: 'nerf',
                before: '0.01%',
                after: '0.008%'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '258',
                balance: 'buff',
                before: '5',
                after: '7'
            },
            {
                unlock: 'miningEnhancement',
                type: 'balance',
                text: '259'
            },
            {
                unlock: 'miningSmeltery',
                type: 'balance',
                text: '260'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '261',
                balance: 'nerf',
                before: 'x1.05',
                after: 'x1.02'
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [10]
            },
            {
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [8]
            },
            {
                unlock: 'gemFeature',
                type: 'new',
                text: 'addedGemUpgrade',
                params: [2]
            }
        ],
        note: [
            {
                type: 'new',
                text: '274'
            }
        ],
        village: [
            {
                type: 'qol',
                text: '265'
            },
            {
                type: 'balance',
                text: '266'
            },
            {
                type: 'balance',
                text: '273'
            },
            {
                unlock: 'villagePrestige',
                type: 'balance',
                text: '267',
                balance: 'buff',
                before: '1x',
                after: '4x'
            },
            {
                unlock: 'villageCoinUpgrades',
                type: 'balance',
                text: '268'
            }
        ],
        horde: [
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '255'
            },
            {
                unlock: 'hordeCorruptedFlesh',
                type: 'balance',
                text: '256',
                balance: 'nerf',
                before: '+20%*',
                after: 'x1.15'
            },
            {
                unlock: 'hordeEquipmentMastery',
                type: 'clarity',
                text: '275'
            }
        ],
        farm: [
            {
                unlock: 'farmCropExp',
                type: 'change',
                text: '230'
            },
            {
                unlock: 'farmCropExp',
                type: 'change',
                text: '231'
            },
            {
                unlock: 'farmCropExp',
                type: 'new',
                text: '232'
            },
            {
                type: 'balance',
                text: '233'
            },
            {
                type: 'new',
                text: '234'
            },
            {
                unlock: 'farmCropExp',
                type: 'change',
                text: '235'
            },
            {
                type: 'new',
                text: '236'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '237'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '238'
            },
            {
                unlock: 'farmCropExp',
                type: 'qol',
                text: '239'
            },
            {
                type: 'info',
                text: '240'
            },
            {
                unlock: 'farmFertilizer',
                type: 'clarity',
                text: '241'
            },
            {
                type: 'change',
                text: '242'
            },
            {
                unlock: 'farmCropExp',
                type: 'new',
                text: '243'
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [1]
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '253'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '254'
            },
            {
                unlock: 'farmCropExp',
                type: 'change',
                text: '269'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '271',
                balance: 'nerf',
                before: '+100%',
                after: '+10%'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '272'
            }
        ],
        treasure: [
            {
                unlock: 'eventFeature',
                type: 'balance',
                text: '263',
                balance: 'nerf',
                before: '200%',
                after: '125%'
            },
            {
                type: 'balance',
                text: '264',
                balance: 'nerf',
                before: '+25%',
                after: '+10%'
            },
            {
                type: 'bugfix',
                text: '270'
            }
        ],
        cryolab: [
            {
                unlock: 'farmCropExp',
                type: 'change',
                text: '251'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '252',
                balance: 'buff',
                before: '20/d',
                after: '500/d'
            }
        ],
        gallery: [
            {
                type: 'clarity',
                text: '276'
            }
        ],
        mining_1: [
            {
                type: 'balance',
                text: '262'
            },
            {
                type: 'new',
                text: 'addedUpgrade',
                params: [1]
            },
            {
                type: 'new',
                text: 'addedPrestigeUpgrade',
                params: [3]
            }
        ]
    }
}
